"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("../config");
const errors_1 = require("../errors");
const api_1 = require("../api");
const shared_1 = require("../shared");
const updateSchedule = (scheduleParams_1, ...args_1) => __awaiter(void 0, [scheduleParams_1, ...args_1], void 0, function* (scheduleParams, requestConfig = (0, config_1.getRequestConfig)()) {
    const { id } = scheduleParams, params = __rest(scheduleParams, ["id"]);
    const resourcePath = (0, shared_1.getResourcePath)(scheduleParams);
    const path = `${resourcePath}/schedules/${id}`;
    try {
        return yield (0, api_1.put)({ path, body: params, config: requestConfig });
    }
    catch (err) {
        (0, shared_1.handleError)(err, errors_1.ScheduleUpdateError);
    }
});
exports.default = updateSchedule;
